import React, { useRef } from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import Text from "components/Text";
import styles from "../AddEvent/AddEvent.module.scss";
import crossIcon from "assets/images/cross.svg";
import { withTranslation } from "react-i18next";
export const editTypesVariables = {
  singleEvent: 1,
  thisAndFutureEvent: 2,
  allEvent: 3,
};
function EditOptionsModal({
  t,
  isOpen,
  closeStepOneModal,
  repeatedOptionChanged,
  handleConfirm,
  loader,
  eventKey,
  eventOrShiftTab = false,
  busySlots = false,
}) {
  const inputRefs = useRef([]);
  const options = [
    {
      text: t("scheduler.editModal1Option", eventKey),
      keys: "single-event",
      value: editTypesVariables.singleEvent,
    },
    {
      text: t("scheduler.editModal2Option", {
        ...eventKey,
        eventOrShifts: t(
          busySlots
            ? "accountOwner.busySlots"
            : `accountOwner.${eventOrShiftTab ? "shifts" : "events"}`
        ).toLowerCase(),
      }),
      keys: "future-events",
      value: editTypesVariables.thisAndFutureEvent,
    },
    {
      text: t("scheduler.editModal3Option", {
        eventOrShifts: t(
          busySlots
            ? "accountOwner.busySlots"
            : `accountOwner.${eventOrShiftTab ? "shifts" : "events"}`
        ).toLowerCase(),
      }),
      keys: "all-event",
      value: editTypesVariables.allEvent,
    },
  ];
  if (repeatedOptionChanged) {
    options.splice(0, 1);
  }
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => closeStepOneModal(false)}
      className="modal-dialog-centered modal-width-660 new-group-modal"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => closeStepOneModal(false)}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        {/* Header */}
        <Text
          size="25px"
          marginBottom="10px"
          weight="500"
          color="#111b45"
          className="text-capitalize"
        >
          {t("scheduler.editEventModalHeading", eventKey)}
        </Text>

        <Text size="16px" marginBottom="10px" weight="300" color="#535B5F">
          {t("scheduler.editEventModalDescription", eventKey)}
        </Text>

        {/* Member list */}
        <ul
          className="modal-employee-list reset-top-property group-list"
          id="scrollableDiv"
        >
          {options.map(({ keys, text, value }, i) => (
            <li key={keys}>
              <div
                className={`${
                  options?.length - 1 === i ? "mt-3 " : styles.border_list
                } ch-radio`}
              >
                <label htmlFor={keys}>
                  <input
                    type="radio"
                    ref={(ref) => (inputRefs.current[i] = ref)}
                    id={keys}
                    value={value}
                    defaultChecked={!i}
                    name="edit-event"
                  />
                  <span>
                    <Text size="14px" weight="600" color="#2F3245">
                      {text}
                    </Text>
                  </span>
                </label>
              </div>
            </li>
          ))}
        </ul>

        {/* Footer buttons */}
        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-4"
          title={t("edit")}
          disabled={loader}
          onClick={() => {
            inputRefs.current.forEach((res) => {
              if (res?.checked && res?.value) {
                handleConfirm(+res?.value);
              }
            });
          }}
        >
          {loader ? (
            <div className="loader-container text-center">
              <Spinner animation="border" className="loader-spinner" />
            </div>
          ) : (
            t("edit")
          )}
        </button>
        <button
          className="button button-round button-border btn-mobile-link button-dark mb-md-3  mt-md-4"
          onClick={() => closeStepOneModal(false)}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(EditOptionsModal);
